// extracted by mini-css-extract-plugin
export default {"wrap":"aF-z","fullWidth":"bF-z","hideOnDesktop":"cF-z","content":"dF-z","hasOpenedNav":"eF-z","crumbsList":"fF-z","dropdownsWrap":"gF-z"};